import { loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Form from './Form';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'modules/TrailerManagement');

const Component = (props) => {
  return (
    <Styled.Wrapper>
      <Form {...props} Styled={Styled} />
    </Styled.Wrapper>
  );
};

export default Component;

Component.propTypes = {
  history: PropTypes.object.isRequired,
};
